module.exports = __webpack_public_path__ + "media/images/weather/51_night-fe296fa5cf3f52cbb4184a669ac7d0d0.png";